function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { useRef } from 'react';
import { Controlnput } from "../../CommonComponents";
var style1 = {
  display: 'flex',
  flexDirection: 'row',
  flexGrow: 1,
  overflow: 'hidden'
};
export function Control(_ref) {
  var selectProps = _ref.selectProps,
      innerProps = _ref.innerProps,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var inputRef = useRef();

  var onTouch = function onTouch() {
    inputRef.current.focus();
    selectProps.setMenuIsOpen(true);
  };

  var style = {
    display: 'flex',
    flexDirection: 'column',
    cursor: 'pointer',
    minWidth: selectProps.minWidth
  };
  return (
    /*#__PURE__*/
    // eslint-disable-next-line
    React.createElement("div", _extends({
      ref: innerRef
    }, innerProps, {
      style: style,
      onTouchEnd: onTouch,
      onClick: onTouch
    }), /*#__PURE__*/React.createElement(Controlnput, {
      selectProps: selectProps,
      innerRef: innerRef,
      innerProps: innerProps
    }, /*#__PURE__*/React.createElement("div", {
      style: style1,
      ref: inputRef
    }, children)))
  );
}